import { action as apiAction } from 'api/Api'
import {
  removeResponsible,
  removeUser,
} from 'routes/Board/redux/cards'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  userId: number
}

const requestRemoveUser = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, userId } = payload

  const state = getState()

  const currentResponsible = state['view-board'].cards[cardId].responsible

  let optimisticAction
  if (userId === currentResponsible) {
    optimisticAction = optimisticDispatch(dispatch, removeResponsible({
      id: cardId
    }))
  } else {
    optimisticAction = optimisticDispatch(dispatch, removeUser({
      id: cardId,
      userId
    }))
  }

  try {
    await apiAction('RemoveUserFromCard', {
      cardId,
      userId
    })
  } catch (error) {
    if (error.code === 501) {
      const state = getState()

      try {
       await sweetalert({
          text: state.kanbo.locale.messages['CARD_REMOVE_USER_VALIDATE'],
          type: 'info'
        })
      } catch (e) {}
    } else if (error.code !== 401) {
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}

export default requestRemoveUser
